<template>
  <transition name="modal">
    <div class="vgs" v-if="index !== null">
      <LightBox :media="images" :show-caption="hasCaption" @onImageChanged="setIndex" @onClosed="close" :start-at="startAt"></LightBox>
    </div>
  </transition>
</template>

<script>
import LightBox from "./lightbox/LightBox"
export default {
  data() {
    return {
      images: [],
      index: null,
      startAt: null,
      image: null,
      galleryXPos: 0,
      thumbnailWidth: 120,
    }
  },
  computed: {
    text() {
      //const img = this.images[this.index];
      //return img.desc;
      return ""
    },
    hasCaption() {
      return this.images[this.index].caption !== ""
    },
    isMultiple() {
      return this.images.length > 1
    },
  },
  created() {
    this.$events.$on("lightbox-gallery:open", this.show)
    this.$events.$on("lightbox-gallery:close", this.close)
  },
  unmounted() {
    this.$events.$off("lightbox-gallery:close", this.close)
    this.$events.$off("lightbox-gallery:open", this.show)
  },
  methods: {
    show(images, startIndex = 0, base = false) {
      if (typeof $zoho !== "undefined" && $zoho?.salesiq?.floatbutton) {
        $zoho.salesiq.floatbutton.visible("hide")
      }

      this.base = base ? base : ""

      this.images = images.map((image) => {
        return {
          src: `${image.src}?tr=w-1200,h-900`,
          srcset: `${image.src}?tr=w-2400,h-1800 2x`,
          thumb: `${image.src}?tr=w-100,h-100`,
          caption: image.caption,
          data: image,
        }
      })

      //this.images = images
      this.index = startIndex
      this.startAt = startIndex
    },
    setIndex(ind) {
      this.index = ind
    },
    toggle(open) {
      //if(!open){ //this.close(); }
    },
    close() {
      this.index = null
      this.images = []

      if (typeof $zoho !== "undefined" && $zoho?.salesiq?.floatbutton) {
        $zoho.salesiq.floatbutton.visible("show")
      }
      this.$emit("close")
    },
  },
  components: {
    LightBox,
  },
}
</script>
